<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <v-form ref="form" lazy-validation>
          <app-drawer class="app--drawer"></app-drawer>
          <app-toolbar class="app--toolbar" v-bind:class="{ 'toolbar-expanded': sidebarExpanded}"></app-toolbar>
          <v-main>
            <!-- Page Header -->
            <page-header v-if="$route.meta.breadcrumb"></page-header>
            <div class="page-wrapper">
              <router-view></router-view>
            </div>
            <!-- App Footer -->
            <v-footer height="auto" class="pa-3 pt-10 app--footer">
              <span class="caption">csimex.vn design &copy; {{ new Date().getFullYear() }}</span>
              <v-spacer></v-spacer>
            </v-footer>
          </v-main>
          <!-- Go to top -->
          <app-fab></app-fab>
          <v-navigation-drawer
            class="setting-drawer"
            temporary
            right
            v-model="rightDrawer"
            hide-overlay
            fixed
          ></v-navigation-drawer>
          <v-snackbar transition="slide-x-transition" :timeout="snackbar.timeout ? snackbar.timeout : 5000" :color="snackbar.color" v-model="snackbar.show" top centered multi-line rounded>
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                icon
                v-bind="attrs"
                @click="snackbar.show = false"
              >
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
          <v-dialog v-model="delDialog" persistent max-width="400">
            <v-card class="text-center pa-4">
              <v-card-text>
                <div class="mx-auto mb-4 d-flex align-center justify-center" style="width: 48px; height: 48px; background-color: #fee2e2; border-radius: 50%;">
                  <v-icon color="red" large>warning</v-icon>
                </div>
                <h3 class="font-weight-bold text-h6 mb-2" style="color: #0f172a">{{ $t('actions.confirm') }}</h3>
                <p class="text-body-2 mb-0" style="color: #64748b">{{ delMessage || $t('messages.confirm_delete') }}</p>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn text @click="delDialog = false" class="px-4 text-capitalize font-weight-bold" style="color: #64748b; background-color: #f1f5f9;">{{ $t('actions.cancel') }}</v-btn>
                <v-btn color="error" @click="delConfirmed" class="px-4 text-capitalize font-weight-bold elevation-1 ml-3">{{ $t('actions.confirm') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-form>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-dialog v-model="dialogMessage" width="500" v-if="isConfirm">
      <v-card>
        <v-card-title class="grey lighten-2">
          Thông báo
        </v-card-title>
        <v-card-text class="pt-6" v-html="configuration.MessageContent">
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogMessage = false">
            Đóng
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import AppFab from "@/components/AppFab";
import PageHeader from "@/components/PageHeader";
import AppEvents from "./event";
import { mapState } from "vuex";
import Vue from 'vue';
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader
  },
  data: () => ({
    dialogMessage: false,
    delMessage: "",
    delDialog: false,
    delId: 0,
    rightDrawer: false,
    isConfirm: false,
    snackbar: {
      show: false,
      text: "",
      color: ""
    }
  }),
  computed: {
    ...mapState({
        sidebarExpanded: state => state.commons.sidebarExpanded,
        configuration: state => state.configuration.selected
    }),
    showCustomerMessage() {
      return Vue.$cookies.get('showCustomerMessage');
    }
  },
  methods: {
    delConfirmed() {
      this.delDialog = false;
      this.$root.$emit('CONFIRMED_REMOVE_DATA', this.delId);
    }
  },
  // watch: {
  //   configuration() {
  //       if(this.configuration && !this.showCustomerMessage) {
  //         this.isConfirm = this.configuration.MessageContent !== null && this.configuration.MessageContent !== '';
  //         if(this.isConfirm) {
  //           Vue.$cookies.set('showCustomerMessage', true, 60 * 60);
  //         }
  //       }
  //   }
  // },
  mounted() {
    if(this.$store.state.authentication.user) {
      this.$store.dispatch("configuration/getDetail", 1);
    }
  },
  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.$store.commit("commons/setSidebarExpanded", {
        expanded: !this.sidebarExpanded
      });
    });
  }
};
</script>

<style lang="stylus" scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}

.toolbar-expanded {
  padding: 0 0 0 230px;
}
</style>
